module.exports = __webpack_public_path__ + "media/images/icon-edu-check-b625d721eae403d0e94fe9079975b053.svg";